import React from 'react'

import { Box, Loader, makeAppStyles, Typography } from '@percept/mui'

import { OpenInNew } from '@percept/mui/icons'

import { DashboardCard } from 'components/DashboardCard'

import axios from 'axios'

import { useQuery, UseQueryResult } from 'react-query'

import qs from 'query-string'

import { makeClientQueryFn } from '@percept/hooks'
import { DashboardHomeCardProps } from './typings'
import { errorContent } from './common'


const canonicalDomain = 'https://wearepercept.com'

const baseURL = `https://corsproxy.io`

const newsRoute = '/platform-releases'

const externalLink = canonicalDomain + newsRoute

const publicWebsiteClient = axios.create({ baseURL })


type RSSArticle = {
  title: string
  description: string | null
  href: string
  publishedDate: Date | null
}

const rssAdapter = (response: string): RSSArticle[] => {
  const parser = new DOMParser()
  const xml = parser.parseFromString(response, 'text/xml')
  const articles: RSSArticle[] = Array.from(xml.querySelectorAll('item')).map( item => {
    let publishedDate = null
    const articlePubDate = item.querySelector('pubDate')
    if( articlePubDate ){
      publishedDate = new Date(articlePubDate.textContent)
    }
    return {
      title: (item.querySelector('title') as HTMLTitleElement).textContent,
      description: (item.querySelector('description') as Element).childNodes[0].nodeValue,
      href: (item.querySelector('link') as Element).textContent,
      publishedDate,
    }
  })
  return articles
}

const useRSSFeed = (): UseQueryResult<RSSArticle[]> => {
  return useQuery<RSSArticle[]>({
    queryKey: ['dashboardNews'],
    queryFn: makeClientQueryFn<string, RSSArticle[]>(
      publicWebsiteClient,
      {
        url: '/',
        params: {
          url: `${canonicalDomain}${newsRoute}?format=rss`,
          key: '647f53c5',
        },
        paramsSerializer: qs.stringify,
      },
      (response) => (
        rssAdapter(response.data)
      )
    ),
  })
}


const useStyles = makeAppStyles( theme => ({
  article: {
    marginBottom: theme.spacing(2),
    '&:last-of-type': {
      marginBottom: 0,
    },
    '& h4': {
      margin: theme.spacing(1, 0, 0.5, 0),
      fontWeight: theme.typography.fontWeightBold,
    },
    '& p': {
      margin: 0,
    },
    '& figure': {
      margin: 'unset',
    },
    '& img': {
      height: 'unset',
      maxWidth: '100%',
      margin: theme.spacing(1, 0),
    },
  },
  title: {
    fontSize: 14,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: theme.transitions.create('color'),
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  linkIcon: {
    fontSize: 18,
    marginRight: theme.spacing(0.75),
    position: 'relative',
    top: 1,
  },
}))


export const DashboardNews = (props: DashboardHomeCardProps) => {
  const articlesQuery = useRSSFeed()
  const classes = useStyles()
  return (
    <DashboardCard
      title={`What's New`}
      tooltipContent='The latest features and insights launched on the platform (opens in new window).'
      externalLink={externalLink}
      isRefetching={articlesQuery.isRefetching}
      {...props}>
      { articlesQuery.error ? (
        errorContent
      ) : !articlesQuery.data ? (
        <Loader preset='fullsize' minHeight='10rem' />
      ) : (
        <Box p={2}>
          { articlesQuery.data.slice(0, 4).map( a => (
            <div key={a.title} className={classes.article}>
              <a
                className={classes.link}
                href={a.href}
                rel='noopener noreferrer'
                target='_blank'>
                <OpenInNew className={classes.linkIcon} color='inherit' />
                <Typography variant='h5' className={classes.title}>{ a.title }</Typography>
              </a>
              {/* { a.description && (
                <Typography paragraph>
                  <div dangerouslySetInnerHTML={{ __html: a.description}} />
                </Typography>
              )} */}
            </div>
          ))}
        </Box>
      )}
    </DashboardCard>
  )
}
